import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4906e296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-title space-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "다른 조건으로 제안", -1))
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"detail_info\" data-v-4906e296><div class=\"space-between\" data-v-4906e296><div class=\"sub_message\" data-v-4906e296> 협의 제안 가격 </div><div class=\"value\" data-v-4906e296><span class=\"strong\" data-v-4906e296>6,000 </span>원 </div></div><div class=\"space-between\" data-v-4906e296><div class=\"sub_message\" data-v-4906e296> 판매 </div><div class=\"value\" data-v-4906e296><span class=\"strong\" data-v-4906e296>234,605,000 </span>원 </div></div></div>", 1)
const _hoisted_8 = { class: "space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "닫기")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "left_btn btn_groups",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelToLeadAngel && _ctx.cancelToLeadAngel(...args)))
          }, " 협의 취소 "),
          _createElementVNode("button", {
            class: "right_btn btn_groups",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismiss('suggestToLeadAngel')))
          }, " 다른 조건으로 제안 ")
        ])
      ])
    ])
  ]))
}